const pathDeobfuscate = path => path.replace(/\^/g, ".").replace(/\{/g, "/");

export default pathDeobfuscate;
